import { Directive, Input } from '@angular/core';
import { NgbPopover } from '@mattlewis92/ng-bootstrap'

@Directive({ selector: '[ngbPopover]' })
export class PopoverIsOpenDirective {
    
    @Input() set popoverIsOpen(value:boolean) {
        if (value) {
            if (!this.popover.isOpen()) this.popover.open();
        } else {
            if (this.popover.isOpen()) this.popover.close();
        }
    };

    constructor(private popover: NgbPopover) {}

}


// WEBPACK FOOTER //
// ./web/static/services/directives/PopoverIsOpen.ts